import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e8d3adb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-other"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, null, -1));
const _hoisted_3 = {
  class: "friend-link"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "footer-box"
};
const _hoisted_6 = {
  class: "footer-menu-box"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "copyright"
}, "©2021 百度有限公司 版权所有"), /*#__PURE__*/_createElementVNode("span", {
  class: "record"
}, "京公网安备1100000200001号")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(['trade-footer', _ctx.adaptWise && 'is-foot-adapt-wise'])
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.friendLink, linkItem => {
    return _openBlock(), _createElementBlock("a", {
      key: linkItem.url,
      class: "link-item",
      href: linkItem.url,
      target: "_blank"
    }, _toDisplayString(linkItem.text), 9, _hoisted_4);
  }), 128))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerMenus, menu => {
    return _openBlock(), _createElementBlock("a", {
      key: menu.text,
      class: "item",
      href: menu.url,
      target: "_blank"
    }, _toDisplayString(menu.text), 9, _hoisted_7);
  }), 128))]), _hoisted_8])], 2);
}